import React from 'react';
import { BloodworkAnalysis } from '../../models/BloodworkAnalysis';
import { analyzeMvx } from '../../models/MetabolicVulnerability';
import { MVX_ABOUT } from '../../models/mvxAbout';
import { inputsFromBloodwork } from './metabolic-vulnerability-insights';

/**
 * MVX "About" tab — a plain-language description for every MVX marker the client
 * has a value for, in the same markup the app's AboutSection uses (title +
 * bulleted description). Content is the static `MVX_ABOUT` module (MVX isn't a
 * Section, so it can't use the DB-driven findAboutConsideration path).
 */
interface Props {
  bloodworkAnalysis: BloodworkAnalysis;
}

export class MvxAboutSection extends React.Component<Props> {
  static shouldRender(ba: BloodworkAnalysis | undefined): boolean {
    return analyzeMvx(inputsFromBloodwork(ba)).anyEntered;
  }

  render() {
    const result = analyzeMvx(inputsFromBloodwork(this.props.bloodworkAnalysis));
    const entered = new Set<string>([
      ...result.indices.filter(i => i.hasValue).map(i => i.id),
      ...result.factors.filter(f => f.hasValue).map(f => f.id),
    ]);
    const entries = MVX_ABOUT.filter(e => entered.has(e.id));

    if (entries.length === 0) {
      return <p className="text-muted">No marker descriptions are available yet.</p>;
    }

    return (
      <span>
        {entries.map((e, idx) => (
          <span key={idx}>
            <span className="consideration-title">{e.title}</span>
            <ul>
              <li>{e.description}</li>
            </ul>
          </span>
        ))}
      </span>
    );
  }
}

export default MvxAboutSection;
